import { BasePath } from '@constants/Auth';
import { SafeAny } from '@models/common';
import axios from 'axios';

export const setBaseUrl = (url: string) => {
  axios.defaults.baseURL = url;
};

export const setTenantId = (id: string) => {
  axios.defaults.headers["TenantId"] = id;
};

export const handleApiError = (error: SafeAny) => {
  if (error.response?.status === 403) {
    window.location.replace(BasePath + '/access_denied');
  }
};

export default axios;
